import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { Grid } from "@mui/material";
import MetricPartition from "../../metrics/metric-partition";
import { useApiTenant } from "../../../../api/api-tenant";
import useOnScreen from "../../../../helpers/on-screen";
import { metricColors } from "../../../../helpers/colors";
export default function TicketsMetricsUser({ type, group_id, campaign, globalRange, setGlobalRange, globalStartDate, globalStartTime, globalEndDate, globalEndTime, isChosenGlobalCustomRange, }) {
    const { t } = useTranslation();
    const api = useApiTenant();
    const ref = useRef(null);
    const onScreen = useOnScreen(ref, "-100px");
    const [wasOnScreen, setWasOnScreen] = useState(false);
    const [ticketsUserCreatedData, setTicketsUserCreatedData] = useState([]);
    const [ticketsUserCreatedError, setTicketsUserCreatedError] = useState(false);
    const [ticketsUserCreatedCachedAt, setTicketsUserCreatedCachedAt] = useState("");
    const [ticketsUserCreatedRange, setTicketsUserCreatedRange] = useState("total");
    const [ticketsUserCreatedLoading, setTicketsUserCreatedLoading] = useState(true);
    const [ticketsUserCreatedMetricsRefresh, setTicketsUserCreatedMetricsRefresh] = useState(false);
    const [ticketsUserCreatedStartDate, setTicketsUserCreatedStartDate] = useState("");
    const [ticketsUserCreatedEndDate, setTicketsUserCreatedEndDate] = useState("");
    const [ticketsUserCreatedStartTime, setTicketsUserCreatedStartTime] = useState("");
    const [ticketsUserCreatedEndTime, setTicketsUserCreatedEndTime] = useState("");
    const [isChosenUserCreatedCustomRange, setIsChosenUserCreatedCustomRange] = useState(false);
    const [ticketsUserCreatedChosenStatuses, setTicketsUserCreatedChosenStatuses] = useState([]);
    const [ticketsUserCreatedChosenPriorities, setTicketsUserCreatedChosenPriorities] = useState([]);
    const [ticketsUserAssignedData, setTicketsUserAssignedData] = useState([]);
    const [ticketsUserAssignedError, setTicketsUserAssignedError] = useState(false);
    const [ticketsUserAssignedCachedAt, setTicketsUserAssignedCachedAt] = useState("");
    const [ticketsUserAssignedRange, setTicketsUserAssignedRange] = useState("total");
    const [ticketsUserAssignedLoading, setTicketsUserAssignedLoading] = useState(true);
    const [ticketsUserAssignedMetricsRefresh, setTicketsUserAssignedMetricsRefresh] = useState(false);
    const [ticketsUserAssignedStartDate, setTicketsUserAssignedStartDate] = useState("");
    const [ticketsUserAssignedEndDate, setTicketsUserAssignedEndDate] = useState("");
    const [ticketsUserAssignedStartTime, setTicketsUserAssignedStartTime] = useState("");
    const [ticketsUserAssignedEndTime, setTicketsUserAssignedEndTime] = useState("");
    const [isChosenUserAssignedCustomRange, setIsChosenUserAssignedCustomRange] = useState(false);
    const [ticketsUserAssignedChosenStatuses, setTicketsUserAssignedChosenStatuses] = useState([]);
    const [ticketsUserAssignedChosenPriorities, setTicketsUserAssignedChosenPriorities] = useState([]);
    const getTicketsUserCreatedValues = invalidateCache => {
        setTicketsUserCreatedLoading(true);
        if (ticketsUserCreatedError)
            setTicketsUserCreatedError(false);
        let startTime;
        let endTime;
        if (ticketsUserCreatedRange === "custom" &&
            ticketsUserCreatedStartDate !== "" &&
            ticketsUserCreatedEndDate !== "") {
            if (ticketsUserCreatedStartTime !== "") {
                startTime =
                    format(new Date(ticketsUserCreatedStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsUserCreatedStartTime), "HH:mm:ss");
            }
            else {
                startTime =
                    format(new Date(ticketsUserCreatedStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsUserCreatedEndTime !== "") {
                endTime =
                    format(new Date(ticketsUserCreatedEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsUserCreatedEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsUserCreatedEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tickets", ticketsUserCreatedRange, "createdBy", undefined, type === "campaign"
            ? "campaign,is_draft"
            : type === "campaign_group"
                ? "campaign,is_draft,groups"
                : "is_draft", type === "campaign"
            ? campaign.id + ",0"
            : type === "campaign_group"
                ? campaign.id + ",0," + group_id
                : "0", type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsUserCreatedRange === "custom" ? startTime : undefined, ticketsUserCreatedRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsUserCreatedChosenStatuses.length > 0
            ? ticketsUserCreatedChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsUserCreatedChosenPriorities.length > 0
            ? ticketsUserCreatedChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            let metricsData = [];
            let colorIndex = 0;
            response.data.data
                .sort((a, b) => a.label.localeCompare(b.label))
                .sort((a, b) => a.count - b.count)
                .reverse()
                .map(a => {
                metricsData.push({
                    label: a.label,
                    count: a.count,
                    color: metricColors[colorIndex],
                });
                if (colorIndex + 1 === metricColors.length) {
                    colorIndex = 0;
                }
                else {
                    colorIndex++;
                }
            });
            setTicketsUserCreatedData(metricsData
                .sort(function (a, b) {
                return a.count - b.count;
            })
                .reverse());
            setTicketsUserCreatedCachedAt(response.data.cached_at);
            setTicketsUserCreatedLoading(false);
        })
            .catch(error => {
            setTicketsUserCreatedError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsUserCreatedLoading(false);
            }
        });
        return () => api.cancel();
    };
    const getTicketsUserAssignedValues = invalidateCache => {
        setTicketsUserAssignedLoading(true);
        if (ticketsUserAssignedError)
            setTicketsUserAssignedError(false);
        let startTime;
        let endTime;
        if (ticketsUserAssignedRange === "custom" &&
            ticketsUserAssignedStartDate !== "" &&
            ticketsUserAssignedEndDate !== "") {
            if (ticketsUserAssignedStartTime !== "") {
                startTime =
                    format(new Date(ticketsUserAssignedStartDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsUserAssignedStartTime), "HH:mm:ss");
            }
            else {
                startTime =
                    format(new Date(ticketsUserAssignedStartDate), "yyyy-MM-dd") + " 00:00:00";
            }
            if (ticketsUserAssignedEndTime !== "") {
                endTime =
                    format(new Date(ticketsUserAssignedEndDate), "yyyy-MM-dd") +
                        " " +
                        format(new Date(ticketsUserAssignedEndTime), "HH:mm") +
                        ":59";
            }
            else {
                endTime = format(new Date(ticketsUserAssignedEndDate), "yyyy-MM-dd") + " 23:59:59";
            }
        }
        api.GET_metrics("partition", "tickets", ticketsUserAssignedRange, "ticketDetail.assignees", undefined, type === "campaign"
            ? "campaign,is_draft"
            : type === "campaign_group"
                ? "campaign,is_draft,groups"
                : "is_draft", type === "campaign"
            ? campaign.id + ",0"
            : type === "campaign_group"
                ? campaign.id + ",0," + group_id
                : "0", type === "campaign_group" ? 1 : undefined, invalidateCache ? 1 : undefined, ticketsUserAssignedRange === "custom" ? startTime : undefined, ticketsUserAssignedRange === "custom" ? endTime : undefined, undefined, undefined, campaign && ticketsUserAssignedChosenStatuses.length > 0
            ? ticketsUserAssignedChosenStatuses.map(i => i.id)
            : undefined, campaign && ticketsUserAssignedChosenPriorities.length > 0
            ? ticketsUserAssignedChosenPriorities.map(i => i.id)
            : undefined)
            .then(response => {
            let metricsData = [];
            let colorIndex = 0;
            response.data.data
                .sort((a, b) => a.label.localeCompare(b.label))
                .sort(function (a, b) {
                return a.count - b.count;
            })
                .reverse()
                .map(a => {
                metricsData.push({
                    label: a.label,
                    count: a.count,
                    color: metricColors[colorIndex],
                });
                if (colorIndex + 1 === metricColors.length) {
                    colorIndex = 0;
                }
                else {
                    colorIndex++;
                }
            });
            setTicketsUserAssignedData(metricsData);
            setTicketsUserAssignedCachedAt(response.data.cached_at);
            setTicketsUserAssignedLoading(false);
        })
            .catch(error => {
            setTicketsUserAssignedError(true);
            if (!api.isCancel(error)) {
                console.error(error);
                setTicketsUserAssignedLoading(false);
            }
        });
        return () => api.cancel();
    };
    useEffect(() => {
        if (onScreen && !wasOnScreen)
            setWasOnScreen(true);
    }, [onScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        if (ticketsUserCreatedRange !== "custom") {
            setTicketsUserCreatedStartDate("");
            setTicketsUserCreatedEndDate("");
            setTicketsUserCreatedStartTime("");
            setTicketsUserCreatedEndTime("");
        }
        getTicketsUserCreatedValues(undefined);
    }, [ticketsUserCreatedRange, wasOnScreen]);
    useEffect(() => {
        if (!wasOnScreen)
            return;
        if (ticketsUserAssignedRange !== "custom") {
            setTicketsUserAssignedStartDate("");
            setTicketsUserAssignedEndDate("");
            setTicketsUserAssignedStartTime("");
            setTicketsUserAssignedEndTime("");
        }
        getTicketsUserAssignedValues(undefined);
    }, [ticketsUserAssignedRange, wasOnScreen]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketsUserCreatedRange !== globalRange ||
                (ticketsUserCreatedRange === globalRange &&
                    (globalStartDate !== ticketsUserCreatedStartDate ||
                        globalStartTime !== ticketsUserCreatedStartTime ||
                        globalEndDate !== ticketsUserCreatedEndDate ||
                        globalEndTime !== ticketsUserCreatedEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenUserCreatedCustomRange &&
            ticketsUserCreatedStartDate !== "" &&
            ticketsUserCreatedEndDate !== "") {
            getTicketsUserCreatedValues(undefined);
            setIsChosenUserCreatedCustomRange(false);
        }
    }, [isChosenUserCreatedCustomRange]);
    useEffect(() => {
        if (globalRange &&
            setGlobalRange &&
            globalRange !== "none" &&
            (ticketsUserAssignedRange !== globalRange ||
                (ticketsUserAssignedRange === globalRange &&
                    (globalStartDate !== ticketsUserAssignedStartDate ||
                        globalStartTime !== ticketsUserAssignedStartTime ||
                        globalEndDate !== ticketsUserAssignedEndDate ||
                        globalEndTime !== ticketsUserAssignedEndTime)))) {
            setGlobalRange("none");
        }
        if (isChosenUserAssignedCustomRange &&
            ticketsUserAssignedStartDate !== "" &&
            ticketsUserAssignedEndDate !== "") {
            getTicketsUserAssignedValues(undefined);
            setIsChosenUserAssignedCustomRange(false);
        }
    }, [isChosenUserAssignedCustomRange]);
    useEffect(() => {
        if (ticketsUserCreatedChosenStatuses.length !== 0 ||
            ticketsUserCreatedChosenPriorities.length !== 0) {
            getTicketsUserCreatedValues(false);
        }
    }, [ticketsUserCreatedChosenStatuses.length, ticketsUserCreatedChosenPriorities.length]);
    useEffect(() => {
        if (ticketsUserAssignedChosenStatuses.length !== 0 ||
            ticketsUserAssignedChosenPriorities.length !== 0) {
            getTicketsUserAssignedValues(false);
        }
    }, [ticketsUserAssignedChosenStatuses.length, ticketsUserAssignedChosenPriorities.length]);
    useEffect(() => {
        if (ticketsUserCreatedMetricsRefresh) {
            getTicketsUserCreatedValues(true);
            setTicketsUserCreatedMetricsRefresh(false);
        }
        else if (ticketsUserAssignedMetricsRefresh) {
            getTicketsUserAssignedValues(true);
            setTicketsUserAssignedMetricsRefresh(false);
        }
    }, [ticketsUserCreatedMetricsRefresh, ticketsUserAssignedMetricsRefresh]);
    useEffect(() => {
        if (globalRange && globalRange !== "none" && globalRange !== "custom") {
            if (ticketsUserCreatedRange !== globalRange ||
                ticketsUserAssignedRange !== globalRange) {
                setTicketsUserCreatedRange(globalRange);
                setTicketsUserAssignedRange(globalRange);
                if (wasOnScreen)
                    setWasOnScreen(false);
            }
        }
    }, [globalRange]);
    useEffect(() => {
        if (isChosenGlobalCustomRange &&
            globalRange &&
            globalRange === "custom" &&
            globalStartDate &&
            globalStartDate !== "" &&
            globalEndDate &&
            globalEndDate !== "") {
            if (wasOnScreen)
                setWasOnScreen(false);
            setTicketsUserCreatedStartDate(globalStartDate);
            setTicketsUserCreatedEndDate(globalEndDate);
            setTicketsUserAssignedStartDate(globalStartDate);
            setTicketsUserAssignedEndDate(globalEndDate);
            setTicketsUserCreatedStartTime(globalStartTime ? globalStartTime : "");
            setTicketsUserCreatedEndTime(globalEndTime ? globalEndTime : "");
            setTicketsUserAssignedStartTime(globalStartTime ? globalStartTime : "");
            setTicketsUserAssignedEndTime(globalEndTime ? globalEndTime : "");
            setTicketsUserCreatedRange(globalRange);
            setTicketsUserAssignedRange(globalRange);
        }
    }, [isChosenGlobalCustomRange]);
    return (_jsxs(Grid, Object.assign({ container: true, spacing: 4, width: "100%", marginLeft: "0px", paddingTop: "32px", ref: ref }, { children: [_jsx(Grid, Object.assign({ item: true, xs: 12, md: 6 }, { children: _jsx(MetricPartition, { title: t("tickets.metrics.created-by"), range: ticketsUserCreatedRange, setRange: setTicketsUserCreatedRange, isLoading: ticketsUserCreatedLoading, setIsLoading: setTicketsUserCreatedLoading, cachedAt: ticketsUserCreatedCachedAt, refresh: ticketsUserCreatedMetricsRefresh, setRefresh: setTicketsUserCreatedMetricsRefresh, startDate: ticketsUserCreatedStartDate, setStartDate: setTicketsUserCreatedStartDate, endDate: ticketsUserCreatedEndDate, setEndDate: setTicketsUserCreatedEndDate, startTime: ticketsUserCreatedStartTime, setStartTime: setTicketsUserCreatedStartTime, endTime: ticketsUserCreatedEndTime, setEndTime: setTicketsUserCreatedEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenUserCreatedCustomRange, metricData: ticketsUserCreatedData, type: type, metricType: "created_by", isError: ticketsUserCreatedError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsUserCreatedChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsUserCreatedChosenStatuses : undefined, chosenPriorities: campaign ? ticketsUserCreatedChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsUserCreatedChosenPriorities : undefined }) })), _jsx(Grid, Object.assign({ item: true, xs: 12, md: 6 }, { children: _jsx(MetricPartition, { title: t("tickets.metrics.assigned-to"), range: ticketsUserAssignedRange, setRange: setTicketsUserAssignedRange, isLoading: ticketsUserAssignedLoading, setIsLoading: setTicketsUserAssignedLoading, cachedAt: ticketsUserAssignedCachedAt, refresh: ticketsUserAssignedMetricsRefresh, setRefresh: setTicketsUserAssignedMetricsRefresh, startDate: ticketsUserAssignedStartDate, setStartDate: setTicketsUserAssignedStartDate, endDate: ticketsUserAssignedEndDate, setEndDate: setTicketsUserAssignedEndDate, startTime: ticketsUserAssignedStartTime, setStartTime: setTicketsUserAssignedStartTime, endTime: ticketsUserAssignedEndTime, setEndTime: setTicketsUserAssignedEndTime, globalRange: globalRange, setGlobalRange: setGlobalRange, setIsChosenCustomRange: setIsChosenUserAssignedCustomRange, metricData: ticketsUserAssignedData, type: type, metricType: "assigned_to", isError: ticketsUserAssignedError, statuses: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_statuses : undefined, priorities: campaign ? campaign === null || campaign === void 0 ? void 0 : campaign.ticket_priorities : undefined, chosenStatuses: campaign ? ticketsUserAssignedChosenStatuses : undefined, setChosenStatuses: campaign ? setTicketsUserAssignedChosenStatuses : undefined, chosenPriorities: campaign ? ticketsUserAssignedChosenPriorities : undefined, setChosenPriorities: campaign ? setTicketsUserAssignedChosenPriorities : undefined }) }))] })));
}
